import { SafeImage } from '@/components/common/safe-image';
import type { ContentCommonProps } from '@/components/conversations/conversation-list/message-list-item/message-content/content-common-props';
import { MessageQuote } from '@/components/conversations/conversation-list/message-list-item/message-content/message-quote';
import cn from '@/utils/merge-class-names';

export default function ContentEmoticon({ message }: ContentCommonProps) {
  return (
    <div
      className={cn('group-data-receiver:col-start-2 group-data-receiver:me-4 group-data-sender:col-start-1', {
        'max-h-48 chat-bubble group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary flex flex-col items-center':
          Boolean(message.Quote),
      })}>
      {message.Quote && (
        <MessageQuote
          className='py-1.5 px-2 mb-1'
          quote={message.Quote}
        />
      )}

      <SafeImage
        className='size-16 bg-cover bg-transparent'
        src={message.Message}
        size={[64, 64]}
      />
    </div>
  );
}
